module.exports = __webpack_public_path__ + "media/images/padlet_logo_rainbow-c6de64f57a57c7a5ac185b09e2aa768d.png";